import produce from 'immer';
import { SET_ALL_USERS, LOADER_STATUS, SET_CREATE_USER_MODAL,ON_NOTIFY,TOTAL_RECORD, GET_ALL_COMPANIES,SET_ALL_STATE_CODE,SET_STATE_PAGE  } from './constants';


export const initialState = {
  loaderStatus: false,
  isModalActive: false,
  users: [],
  companies: [],
  stateCodes: [],
  totalRecords: '',
  statePage: 1,
  records: '',
  status: false,
  msg: '',

};


const managePincodeReducer = (state = initialState, action) =>{
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus:action.loaderStatus
      }
    case SET_ALL_USERS:
      return {
        ...state,
        users:action.users
      }
    case SET_CREATE_USER_MODAL:
      return {
        ...state,
        isModalActive:action.isModalActive
      }
    case ON_NOTIFY:
      return {
        ...state,
        status:action.status,
        msg:action.msg
      }
    case GET_ALL_COMPANIES:
      return {
        ...state,
        companies:action.payload
      }
    case TOTAL_RECORD:
      return {
        ...state,
        totalRecords:action.totalRecords,
        records:action.records
      }
    case SET_ALL_STATE_CODE:
      return {
        ...state,
        stateCodes:action.stateCodes
      }
    case SET_STATE_PAGE:
      return {
        ...state,
        statePage:action.failPage
      }
    default:
      return state;
  }
}
    
    

export default managePincodeReducer;